module.exports = __webpack_public_path__ + "img/rs.2d9308e0.jpg";